/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import classnames from 'classnames';
import * as React from 'react';

export interface IBusinessSignUpErrorProps {
    id?: string;
    className: string;
    type?: string;
    message?: string;
}

export const SignUpError: React.FC<IBusinessSignUpErrorProps> = ({ id, className, type = 'page', message }) => {
    const errorClassName = `${className}__${type}-error`;

    return (
        <div
            id={id}
            className={classnames(errorClassName, 'error', `${type}Level`)}
            role='alert'
            aria-live='assertive'
            aria-label='Address fields are optional. If you choose to submit an address, please complete the rest of the address fields.'
        >
            <p className={`${errorClassName}-text`}>{message}</p>
        </div>
    );
};

export default SignUpError;
